module.exports = __webpack_public_path__ + "img/line-1.a75e8613.svg";